//Make all external links open in a new tab
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

//This function shows the NSW map & hides all others
function shownsw() {
  var elements = document.getElementsByClassName("mapnsw");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "block";
        }

  var elements = document.getElementsByClassName("mapnt");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }
  
  var elements = document.getElementsByClassName("mapqld");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapsa");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("maptas");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapvic");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapwa");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }
}

//This function shows the NT map & hides all others
function shownt() {
  var elements = document.getElementsByClassName("mapnsw");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapnt");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "block";
        }
  
  var elements = document.getElementsByClassName("mapqld");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapsa");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("maptas");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapvic");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapwa");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }
}

//This function shows the QLD map & hides all others
function showqld() {
  var elements = document.getElementsByClassName("mapnsw");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapnt");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }
  
  var elements = document.getElementsByClassName("mapqld");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "block";
        }

  var elements = document.getElementsByClassName("mapsa");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("maptas");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapvic");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapwa");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }
}

//This function shows the SA map & hides all others
function showsa() {
  var elements = document.getElementsByClassName("mapnsw");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapnt");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }
  
  var elements = document.getElementsByClassName("mapqld");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapsa");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "block";
        }

  var elements = document.getElementsByClassName("maptas");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapvic");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapwa");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }
}

//This function shows the TAS map & hides all others
function showtas() {
  var elements = document.getElementsByClassName("mapnsw");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapnt");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }
  
  var elements = document.getElementsByClassName("mapqld");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapsa");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("maptas");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "block";
        }

  var elements = document.getElementsByClassName("mapvic");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapwa");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }
}

//This function shows the VIC map & hides all others
function showvic() {
  var elements = document.getElementsByClassName("mapnsw");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapnt");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }
  
  var elements = document.getElementsByClassName("mapqld");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapsa");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("maptas");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapvic");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "block";
        }

  var elements = document.getElementsByClassName("mapwa");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }
}

//This function shows the WA map & hides all others
function showwa() {
  var elements = document.getElementsByClassName("mapnsw");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapnt");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }
  
  var elements = document.getElementsByClassName("mapqld");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapsa");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("maptas");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapvic");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "none";
        }

  var elements = document.getElementsByClassName("mapwa");
  for (let i = 0; i < elements.length; i++) {
            var x = elements[i];
              x.style.display = "block";
        }
}
